"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubHeader = void 0;
const elements_ui_components_header_1 = require("@hydrogen/elements.ui.components.header");
const react_1 = __importDefault(require("react"));
const SubHeader = ({ children, navigations }) => (react_1.default.createElement(react_1.default.Fragment, null,
    navigations && (react_1.default.createElement("div", { className: "bg-header-background shadow-header z-20" },
        react_1.default.createElement("div", { className: "max-w-page mx-auto py-3 px-4 sm:px-6 lg:px-16" },
            react_1.default.createElement(elements_ui_components_header_1.NavLinkList, { navigations: navigations, mainNav: false })))),
    children));
exports.SubHeader = SubHeader;
//# sourceMappingURL=SubHeader.js.map